module.exports = __webpack_public_path__ + "img/zhu_xc5.86a7727c.jpg";